//@flow
import * as Immutable from 'immutable';

import { Vehicle } from 'models/flow/Vehicle.js';

import type { VehicleModelType } from 'models/flow/Vehicle.js';

class InternalVehicle extends Vehicle {
    static fromJS(json: VehicleModelType): InternalVehicle {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export { InternalVehicle as Vehicle };
